module.exports = __webpack_public_path__ + "img/Giusto.63008b4b.jpg";